import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import css from './UserDetailField.css';

const UserDetailField = ({ labelId, children }) => (
    <div className={css.userDetailsItem}>
        <div className={css.userDetailsLabel}>
            <Translate id={labelId} />
        </div>
        <div className={css.userDetailsValue}>{children}</div>
    </div>
);

UserDetailField.propTypes = {
    labelId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default UserDetailField;
